module.exports = __webpack_public_path__ + "img/Great Tree.4e5351ee.svg";